import { render, staticRenderFns } from "./CoEditor.vue?vue&type=template&id=518183fc&"
import script from "./CoEditor.vue?vue&type=script&lang=ts&"
export * from "./CoEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CoEditor.vue?vue&type=style&index=0&id=518183fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports